import React from 'react';

import { CommentContent } from '@/apis/comment/types';

import ReplyView from './ReplyView';

type Props = {
  data: CommentContent;
};

export default function Reply({ data }: Props) {
  return (
    <div className="border-b border-solid border-apps-coreProductDivider">
      <ReplyView data={data} />
    </div>
  );
}
